// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip {\n  position: relative;\n  display: block;\n}\n.tooltip .hover-icon {\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n.tooltip:hover .hover-icon {\n  visibility: visible;\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
